import { type FC } from "react";

import { useLensIdSearchParameter, useRetentionData, useTimeRange, useWAUMAUCalculations } from "../../hooks";
import { GranularityInDays, LensGranularity } from "../../models";
import { SubTabHeader } from "../SubTabHeader";

export const RetentionComponent: FC = () => {
    const { lensId } = useLensIdSearchParameter();
    const { selectedTimeRange } = useTimeRange();

    const { dauOverWau, dauOverMau } = useRetentionData(Boolean(!lensId));
    const {
        dauOverWau: dauOverWauPrev,
        dauOverMau: dauOverMauPrev,
        loading,
    } = useRetentionData(selectedTimeRange === LensGranularity.Lifetime, GranularityInDays[selectedTimeRange]);

    const dauOverWauAll = useWAUMAUCalculations(dauOverWau, dauOverWauPrev);
    const dauOverMauAll = useWAUMAUCalculations(dauOverMau, dauOverMauPrev);

    return (
        <>
            <SubTabHeader
                label="DAU/WAU"
                statValue={dauOverWauAll.value}
                diffValue={dauOverWauAll.diffValue}
                tooltip="The proportion of weekly active users who engage with your Lens in a one-day window."
                loading={loading}
            />
            <SubTabHeader
                label="DAU/MAU"
                statValue={dauOverMauAll.value}
                diffValue={dauOverMauAll.diffValue}
                tooltip="The proportion of monthly active users who engage with your Lens in a one-day window."
                loading={loading}
            />
        </>
    );
};
